import axios from "axios";

function searchCountry() {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3031";
      axios
        .get(process.env.ROOT_API + "/country/query")
        .then(result => {
          resolve(result.data.documents);
        })
        .catch(error => {
          reject(error);
        });
    } catch (err) {
      console.log("err in searchCountry: ", err);
    }
  });
}

function person_query(objAux) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3034";
      axios
        .put(process.env.ROOT_API + "/persons/query", objAux, {
          headers: {
            Authorization: objAux.token
          }
        })
        .then(result => {
          resolve(result.data.documents);
        })
        .catch(error => {
          reject(error.response.data.message);
        });
    } catch (error) {
      console.log("Person_Query: ", error);
    }
  });
}

function searchState(country) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3030";
      axios
        .get(process.env.ROOT_API + "/cities/query/" + country)
        .then(result => {
          resolve(result.data.documents);
        })
        .catch(error => {
          reject(error);
        });
    } catch (err) {
      console.log("err in searchState: ", err);
    }
  });
}

function getContact(objData) {
  return new Promise((resolve, reject) => {
    let port = "";
    if (process.env.ROOT_API.includes("viewmedonline")) port = ":3041";
    axios
      .post(
        process.env.ROOT_API + "/contacts/id/list", {
          id: objData.ids
        }, {
          headers: {
            Authorization: objData.token
          }
        }
      )
      .then(result => {
        resolve(result.data.documents[0]);
      })
      .catch(error => {
        reject(error.response.data.message);
      });
  });
}

function listInstitutionContact(objData) {
  return new Promise((resolve, reject) => {
    let port = "";
    if (process.env.ROOT_API.includes("viewmedonline")) port = ":3042";
    axios
      .post(
        process.env.ROOT_API + "/contacts/institutions/list", {
          ids: objData.ids,
          limit: objData.limit
        }, {
          headers: {
            Authorization: objData.token
          }
        }
      )
      .then(result => {
        resolve(result.data.documents);
      })
      .catch(error => {
        reject(error.response.data.message);
      });
  });
}

function deleteInstitutionContact(objData) {
  return new Promise((resolve, reject) => {
    let port = "";
    if (process.env.ROOT_API.includes("viewmedonline")) port = ":3062";
    axios
      .delete(process.env.ROOT_API + "/contacts/delete/" + objData.id, {
        headers: {
          Authorization: objData.token
        }
      })
      .then(result => {
        resolve(result.data.documents);
      })
      .catch(error => {
        reject(error.response.data.message);
      });
  });
}

function listPersonContact(objData) {
  return new Promise((resolve, reject) => {
    let port = "";
    if (process.env.ROOT_API.includes("viewmedonline")) port = ":3043";
    axios
      .post(
        process.env.ROOT_API + "/contacts/persons/list", {
          limit: objData.limit,
          ids: objData.ids,
          type: objData.type
        }, {
          headers: {
            Authorization: objData.token
          }
        }
      )
      .then(result => {
        resolve(result.data.documents);
      })
      .catch(error => {
        reject(error.response.data.message);
      });
  });
}

function userSearch(objAux) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3016";
      axios
        .get(process.env.ROOT_API + "/users/search/" + objAux.user, {
          headers: {
            Authorization: objAux.token
          }
        })
        .then(result => {
          resolve(result.data.documents[0]);
        })
        .catch(error => {
          reject(error);
        });
    } catch (error) {
      console.log("UserSearch: ", error);
    }
  });
}

function getImage(id, token) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3027";
      axios
        .get("http://localhost:3000/get_file/" + id, {
          responseType: "blob",
          headers: {
            "content-type": "multipart/form-data",
            Authorization: token
          }
        })
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          reject(error);
        });
    } catch (err) {
      console.log("err in Get Image: ", err);
    }
  });
}

function institutionSearch(objAux) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3010";
      axios
        .get(process.env.ROOT_API + "/institutions/search/" + objAux.id, {
          headers: {
            Authorization: objAux.token
          }
        })
        .then(result => {
          resolve(result.data.documents[0]);
        })
        .catch(error => {
          reject(error.response.data.message);
        });
    } catch (error) {
      console.log("institutionSearch: ", error);
    }
  });
}

function tokenVideo(objData) {
  return new Promise((resolve, reject) => {
    let port = "";
    if (process.env.ROOT_API.includes("viewmedonline")) port = ":3054";
    axios
      .post(
        process.env.ROOT_API + "/create_session", {
          //ids: objData.ids,
          //type: objData.type
        }, {
          headers: {
            Authorization: objData.token
          }
        }
      )
      .then(result => {
        resolve(result.data.documents);
      })
      .catch(error => {
        reject(error.response.data.message);
      });
  });
}

function insertVideo(objData) {
  return new Promise((resolve, reject) => {
    let port = "";
    if (process.env.ROOT_API.includes("viewmedonline")) port = ":3056";
    axios
      .post(
        process.env.ROOT_API + "/video/insert", {
          issuing: objData.emisor,
          reason: objData.reason,
          receptor: objData.receptor,
          session_id: objData.sessionId,
          online: objData.online,
          share: objData.share,
          emergency: objData.emergency,
          vc_programmed: objData.vc_programmed,
          type: objData.type,
          country_vc: objData.country_vc,
          attention_lvl: 1
        }, {
          headers: {
            Authorization: objData.token
          }
        }
      )
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
}

function contactInsert(objData) {
  return new Promise((resolve, reject) => {
    let port = "";
    if (process.env.ROOT_API.includes("viewmedonline")) port = ":3060";
    axios
      .post(
        process.env.ROOT_API + "/contacts/insert", {
          sender: objData.user,
          receiver: objData.inst,
          status: objData.status,
          category: objData.category,
          control: objData.control,
          shared: objData.shared
        }, {
          headers: {
            Authorization: objData.token
          }
        }
      )
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
}

function contactUpdate(objData) {
  return new Promise((resolve, reject) => {
    let port = "";
    if (process.env.ROOT_API.includes("viewmedonline")) port = ":3061";
    axios
      .put(
        process.env.ROOT_API + "/contacts/update/" + objData.contactId, {
          sender: objData.sender,
          receiver: objData.receiver,
          status: objData.status,
          category: objData.category,
          control: objData.control,
          shared: objData.shared
        }, {
          headers: {
            Authorization: objData.token
          }
        }
      )
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export {
  searchCountry,
  searchState,
  getContact,
  listInstitutionContact,
  listPersonContact,
  deleteInstitutionContact,
  userSearch,
  getImage,
  institutionSearch,
  tokenVideo,
  insertVideo,
  contactInsert,
  contactUpdate,
  person_query
};



// WEBPACK FOOTER //
// ./src/components/institution/profileServ.js